import { render } from "./ImageDetails.vue?vue&type=template&id=5b0ff283"
import script from "./ImageDetails.vue?vue&type=script&lang=js"
export * from "./ImageDetails.vue?vue&type=script&lang=js"

import "./ImageDetails.vue?vue&type=style&index=0&id=5b0ff283&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__